"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_83_20_0 = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
/**
 * map having a SmartPlastics IA => Configuration.UseSmartPlastics = true
 */
const migration_83_20_0 = (json) => {
    var _a;
    if ((_a = json.IAs) === null || _a === void 0 ? void 0 : _a.some((ia) => ia.Artikeltyp === echain_product_models_1.IAArtikeltyp.SmartPlasticsSeparator)) {
        json.UseSmartPlastics = true;
    }
    return json;
};
exports.migration_83_20_0 = migration_83_20_0;
//# sourceMappingURL=migration_83_20_0.js.map